module.exports = function (string) {
  return string.charAt(0).toUpperCase() + string.substring(1);
}

module.exports.words = function (string) {
  return string.replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function (m) {
    return m.toUpperCase()
  })
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/capitalize/index.js
 ** module id = 577
 ** module chunks = 0
 **/